export const ConsumerPostSubmissionFailedViewUat = {
  paragraph: 'workflow.postSubmissionFailed.paragraph'
}
